import { createV3Queries } from "@query/utils/createV3Queries";
import { payersApi } from "@api";
import { QUERY_PAYER_ROWS } from "../../query/search/payer/queries/useQueryPayerRows";
import { QUERY_PAYER_ROWS_ALL } from "../../query/search/payer/queries/useQueryPayerRowsAll";
import { QUERY_PAYER_ROWS_SUMMARY } from "../../query/search/payer/queries/useQueryPayerRowsSummary";
import { queriesPayerRows } from "./queriesPayerRows";

export const queriesPayers = createV3Queries("payersApi", payersApi, {
  // Archiving a payer (deletePayer soft-deactivates) must also refresh the clients
  // list (v3 searchPayerRows) plus the still-v1 payer-row search caches the
  // assignment pickers read, so the archived client drops out of both. This
  // invalidation is always true for the method, so it lives here rather than at
  // each call site.
  deletePayer: () => ({
    dependencies: () => [
      queriesPayerRows.searchPayerRows.queryKeyBase,
      QUERY_PAYER_ROWS,
      QUERY_PAYER_ROWS_ALL,
      QUERY_PAYER_ROWS_SUMMARY
    ]
  })
});
